import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import find from 'lodash/find'
import DocumentTitle from 'react-document-title'

import Actions from './Actions'
import Row from '@components/Details/Row'

class DetailsTab extends Component {
  static propTypes = {
    officeStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  render() {
    const { officeStore, staticData } = this.props
    const { office } = officeStore

    const keyContact = office.keyContact

    const countryName = find(
      staticData.countries,
      country => country.id === office.address.countryId
    ).name

    const timezoneName = find(
      staticData.timezones,
      timezone => timezone.id === office.address.timezoneId
    ).name

    return (
      <DocumentTitle
        title={`${office.officeName} - details | Atheneum Partners`}>
        <div className="details-wrapper animate-intro">
          <Actions officeStore={officeStore} />
          <div className="content">
            <div className="col-2">
              <div className="story">
                <span className="label">Office address</span>
                <div className="group-wrapper">
                  <div className="group">
                    <Row label="Address" text={office.address.address1} />
                    <Row
                      label="Secondary address"
                      text={office.address.address2}
                    />
                    <Row label="City" text={office.address.city} />
                    <Row label="Postal code" text={office.address.postalCode} />
                    <Row label="State/Province" text={office.address.state} />
                    <Row label="Country" text={countryName} />
                    <Row label="Timezone" text={timezoneName} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 col-2--padding">
              <div className="story">
                <span className="label">Client contacts</span>
                <div className="group-wrapper">
                  <div className="group">
                    {office.clients.length > 0
                      ? office.clients.map(contact => (
                        <Row
                          noLabel
                          key={contact.id}
                          text={`${contact.title} ${contact.fullName}`}
                          onClick={() =>
                            this.props.sidebarStore.openSidebar({
                              template: 'client-contact',
                              id: contact.id
                            })
                          }
                        />
                      ))
                      : '-'}
                  </div>
                </div>
              </div>
              <div className="story">
                <span className="label">Office details</span>
                <div className="group-wrapper">
                  <div className="group">
                    <Row
                      label="Key Atheneum contact"
                      text={keyContact && keyContact.fullName}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('sidebarStore', 'staticData')(observer(DetailsTab))
